import { Box, Icon, Link } from '@nimbus-ds/components';
import { DisketteIcon } from '@nimbus-ds/icons';
import { useSavedSearchesUpsell } from 'domains/Orders/Orders/hooks/useSavedSearchesUpsell';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface SaveFiltersButtonProps {
  onClick: () => void;
}
export function SaveFiltersButton({
  onClick,
}: Readonly<SaveFiltersButtonProps>) {
  const t = useTranslationOrders('savedSearches');
  const onClickWithUpsell = useSavedSearchesUpsell(onClick);

  return (
    <Box display="flex">
      <Link
        appearance="primary"
        textDecoration="none"
        fontSize="caption"
        lineHeight="caption"
        onClick={onClickWithUpsell}
      >
        <Icon color="primary-interactive" source={<DisketteIcon size={14} />} />
        {t('saveFilter')}
      </Link>
    </Box>
  );
}
